import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { graphql, useStaticQuery } from 'gatsby';

import { createOptionMap } from '../utilities/misc';
import { rem } from '../utilities/style';
import useUserContext from '../hooks/use-user-context';
import { colors } from '../theme/colors';
import { body } from '../styles/type';
import { shadow } from '../styles/box';

import { ReactComponent as IconHeadphones } from '../images/icons/headphones.svg';
import qrCodeImage from '../images/chinese-qr.png';
import TextRenderer from './TextRenderer';

// Note: Scroll behavior was removed for WWW-5117

const Contact = styled.div`
  ${shadow}
  position: absolute;
  width: max-content;
  left: 0px;
  top: 0px;
  transform: translateX(calc(-100% + -6px));
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.white};
  border-radius: ${rem(10)};
  padding: ${rem(16)};
  opacity: 0;
  visibility: hidden;
  transition: opacity 400ms, visibility 400ms;
  cursor: auto;
  &:hover {
    visibility: visible;
    opacity: 1;
  }
`;

const Sidebar = styled.div`
  position: fixed;
  z-index: 1;
  top: 50%;
  right: 0px;
  background-color: ${colors.white};
  padding: ${rem(8)};
  border-radius: ${rem(10)} 0px 0px ${rem(10)};
  box-shadow: 0 ${rem(2)} ${rem(4)} 0 rgba(0,0,0,0.2);
  //opacity: 0;
  //visibility: hidden;
  transition: opacity 400ms, visibility 400ms;
  /*${({ show }) => show && css`
    opacity: 1;
    visibility: visible;
  `};*/
  &:hover {
    cursor: pointer;
  }

  &:hover ${Contact} {
    visibility: visible;
    opacity: 1;
  }

`;

const SidebarIcon = styled(IconHeadphones)`
  margin-bottom: ${rem(8)};
`;

const SidebarText = styled.div`
  ${body.regular}
  color: ${colors.blue['800']};
  writing-mode: vertical-rl;
  text-orientation: mixed;
  letter-spacing: 0.2em;
`;

const ContactText = styled.div`
  margin-bottom: ${rem(12)};
`;
const ContactPhone = styled.div`
  ${body.small}
  margin-bottom: ${rem(12)};

  a {
    color: inherit;
  }

  &:hover a {
    text-decoration: underline;
  }

`;

const ContactHours = styled.div`
  ${body.small}
`;

const QrImage = styled.img`
  max-width: ${rem(200)};
  margin-bottom: ${rem(12)};
`;

const ChineseContactSidebar = () => {
  const { language } = useUserContext();
  const data = useStaticQuery(graphql`
  query ChineseContactSidebar {
    allContentfulOptionSet(filter: {name: {eq: "chinese_contact_sidebar"}}) {
      nodes {
        ...OptionSetFragment
      }
    }
  }
`);
  const options = createOptionMap(data.allContentfulOptionSet.nodes, language);
  const contactText = options['chinese_contact_sidebar.text'];
  const phoneNumber = options['chinese_contact_sidebar.phone_number'];

  return (
    <Sidebar>
      <SidebarIcon />
      <SidebarText>
        联系我们
      </SidebarText>
      <Contact>
        <ContactText>
          <TextRenderer text={contactText} />
        </ContactText>
        <QrImage
          src={qrCodeImage}
          alt="QR Code"
          height="128px"
        />
        <ContactPhone>
          {'电话咨询: '}
          <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
        </ContactPhone>
        <ContactHours>工作日 9:00-17:00</ContactHours>
      </Contact>
    </Sidebar>
  );
};

export default ChineseContactSidebar;
